'use client';

import { useTranslation } from '@/core/components/providers/TranslationProvider';
import { formatPrice } from '@/core/utils/currency';
import type { B2BTier } from '@/core/utils/b2b-pricing';

/** Progi ilościowe zalogowanej firmy (D9) pod ceną produktu — blok ceny Buildera i strona
 *  produktu bez szablonu. `net`: ceny netto (konto firmowe), inaczej brutto. */
export function B2BTierList({ tiers, taxRate, net, className = '' }: { tiers: B2BTier[]; taxRate: number; net: boolean; className?: string }) {
    const { t, currency, locale } = useTranslation();
    if (!tiers.length) return null;
    return (
        <div className={`product-b2b-tiers text-xs text-slate-600 bg-slate-50 border border-slate-100 rounded-lg p-2 inline-block ${className}`}>
            <p className="font-semibold text-slate-700 mb-1">{t('product.b2b_tiers_title', 'Ceny hurtowe')}</p>
            <ul className="space-y-0.5">
                {tiers.map((tier) => (
                    <li key={tier.min_qty} className="flex justify-between gap-4">
                        <span>{t('product.b2b_tier_from', 'od {n} szt.').replace('{n}', String(tier.min_qty))}</span>
                        <span className="font-semibold tabular-nums">
                            {formatPrice(net ? tier.price / (1 + taxRate / 100) : tier.price, currency, locale)}
                            {net ? ` ${t('product.b2b_net', 'netto')}` : ''}
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
